import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { Users } from '../types'

export const loadUsers = (
  data: PaginatedParams<any>
): PaginatedResponse<Users> => {
  return axios.get('/users', {
    params: {
      ...data
    }
  })
}

export function useLoadUsers(query: PaginatedParams<any>) {
  return useQuery(['users', query], () => loadUsers(query), {
    keepPreviousData: true,
    onError: () =>
      toast.error('Não foi possível carregar a listagem de usuários', {
        toastId: 'loadUsers'
      })
  })
}
